import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../../components/FinalMolGrid/libs/data/gridColumnType";

const initState = {
  projectVersion: "",
  isRelease: "",
  releaseDate: "",
};

export const projectVersionFormData = {
  name: "Project Version Form",
  initialState: initState,
  section: [
    {
      sectionId: "projectVersion",
      title: "Project Version",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "projectVersion",
          label: "Project Version",
          Field_Name: "project version",
          fieldType: FormFieldTypes.INPUT,
          dataField: "projectVersion",
          fieldSetting: {
            placeholder: "Please Enter Project Version",
            allowSpace: true,
            isDisable: false,
            maxLength: 50,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "isRelease",
          label: "Is Release",
          Field_Name: "isrelease",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isRelease",
          fieldSetting: {
            placeholder: "IsRelease",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss:
              "col-lg-4  col-md-6 mb-2 release-btn validation-left-0 checkbox-style mt-2",
          },
        },
        {
          id: " releaseDate",
          label: "Version Release Date",
          Field_Name: "project releasedate",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "releaseDate",
          fieldSetting: {
            placeholder: "Please Select Release Date",
            allowSpace: true,
            isDisable: true,
            dateConfig: {
              dateFormat: "MM/dd/yyyy",
            },
          },
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1  validation-left-0 ",
          },
        },
      ],
    },
  ],
};

export const ProjectVersionGridConfig = {
  columns: [
    {
      name: "Project Version",
      fieldName: "projectVersion",
      allowShort: false,
    },
    {
      name: "Release Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isRelease",
      allowShort: false,
    },
    {
      name: "Release Date",
      fieldName: "releaseDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD/MM/YYYY"
      },
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
};
export default projectVersionFormData;
